document.addEventListener("DOMContentLoaded", function (e) {
	let videos = document.querySelectorAll(".hero.slider .slide.video-embed"); // embedded video slides

	if (videos) {
		const resizeObserver = new ResizeObserver(entries => {
			for (const entry of entries) {
				var width = entry.target.getBoundingClientRect().width;
				var height = entry.target.getBoundingClientRect().height + 120; // +120 is to hide the "tap to unmute" button on mobile

				var correctedWidth = (height * 16) / 9;
				var correctedHeight = (width * 9) / 16;

				if (correctedWidth > width) {
					entry.target
						.querySelector("iframe")
						?.setAttribute(
							"style",
							`height: ${height}px; width: ${correctedWidth}px;`
						);
				} else if (correctedHeight > height) {
					entry.target
						.querySelector("iframe")
						?.setAttribute(
							"style",
							`height: ${correctedHeight}px; width: ${width}px;`
						);
				}
			}
		});

		for (let i = 0; i < videos.length; i++) {
			resizeObserver.observe(videos[i]);
		}
	}
});
